<div class="seatmap__row seatmap__row--{{ INDRA_getAirplane() }}">
    <div class="seatmap__wing seatmap__wing--left" *ngIf="INDRA_rowHasWing(row)" [ngStyle]="INDRA_stylesWing()">
        <app-svg svg="sprite.svg#plane--wing" aria-hidden="true" [alt]="'addMoreSidebars.seatmap.alt.planeLeftWing' | ibeadmin: 'sync'">
        </app-svg>
    </div>
    <div class="seatmap__wing seatmap__wing--right" *ngIf="INDRA_rowHasWing(row)" [ngStyle]="INDRA_stylesWing()">
        <app-svg svg="sprite.svg#plane--wing" aria-hidden="true" [alt]="'Plane right wing'">
        </app-svg>
    </div>

    <div class="seatmap__row-wrapper {{ INDRA_checkSeatFacilities(cabin, 'E') }}">
        <span class="row-id">{{ row.index }}</span>
        <app-seatmap-seat 
            *ngFor="let seat of row.seatsByCode;
            trackBy: trackBySeat"
            class="seatmap__seat {{ INDRA_generateSeatStyle(cabin, seat) }}"
            [class.is-showing]="selectedSeat !== undefined && seat.seatCode === selectedSeat.seatCode" 
            [class.has-passenger]="INDRA_getSeatPassenger(seat)"
            [seatPassenger]="INDRA_getSeatPassenger(seat)"
            [seatIcon]="INDRA_getSeatIcon(seat)"
            [hasIcon]="INDRA_seatHasIcon(seat)"
            [hasBusinessCabin]="seatmapCabinClass === 'business'"
            [seatStyles]="INDRA_generateSeatStyle(cabin, seat)"
            (click)="INDRA_handleSeatClick(seat, true)"
            (mouseenter)="INDRA_handleSeatClick(seat, false)"
            [seat]="seat"
            [cabin]="cabin"
            [seatFeatures]="seatFeatures">
        </app-seatmap-seat>
    </div>

    <div class="seatmap__facilities seatmap__facilities--lavatory" attr.data-seat="{{ row.index }}" *ngIf="INDRA_checkFacilities( row.index, 'LA')">
        WC
    </div>

    <div class="seatmap__facilities seatmap__facilities--exit" attr.data-seat="{{ row.index }}" *ngIf="INDRA_checkFacilities( row.index, 'E')">

        <app-svg class="emergency-exit emergency-exit--left" svg="icons.svg#general--arrow--long_right" aria-hidden="true" [alt]="'addMoreSidebars.seatmap.alt.emergencyExit' | ibeadmin: 'sync'">
        </app-svg>

        <app-svg class="emergency-exit emergency-exit--right" svg="icons.svg#general--arrow--long_right" aria-hidden="true" [alt]="'addMoreSidebars.seatmap.alt.emergencyExit' | ibeadmin: 'sync'">
        </app-svg>

    </div>
</div>